import { withPrefix } from 'gatsby'
import routesConfig from 'src/routes.config'
import variables from 'src/styles/variables'

export const scrollIds = {
  universalTools: 'universal-tools',
  contractBuilding: 'contract-building-and-negotiation',
  dataCapture: 'data-capture-and-enrichment',
  scoringAndPricing: 'scoring-and-pricing',
  policyManagement: 'policy-management',
}

const navItems = [
  {
    title: 'Universal tools',
    id: scrollIds.universalTools,
  },
  {
    title: 'Contract building and negotiation',
    id: scrollIds.contractBuilding,
  },
  {
    title: 'Data capture and enrichment',
    id: scrollIds.dataCapture,
  },
  {
    title: 'Scoring and pricing',
    id: scrollIds.scoringAndPricing,
  },
  {
    title: 'Policy management',
    id: scrollIds.policyManagement,
  },
]

export default {
  metadata: {
    title: 'Digitising the end-to-end quote, bind and issue process. - artificial',
    desc: 'We use AI and Machine Learning technology to digitise and simplify complex data collection, contract negotiation and risk scoring for insurers.',
  },
  ArHeroElongate: {
    title1: 'artificialOS',
    description1: 'Digitising the end-to-end quote, bind and issue process.',
    title2: 'Sophisticated tools in one simple platform',
    description2: [
      'We use AI and Machine Learning to digitise and simplify complex data collection, contract negotiation and pricing.',
      { tag: 'br' },
      { tag: 'br' },
      'We see this as a four step process.',
    ],
    image: {
      src: withPrefix('img/ArHeroElongate1.png'),
    },
    processLegend: [
      'Capture data from the customer or your client',
      'Enrich the data using internal and external sources',
      'Score or prioritise the risk to provide insight',
      'Build a digital contract through algorithms or in person',
    ],
  },
  ArScrollToArticle: {
    title: 'Features',
    navItems,
    sections: [
      {
        color: '#56DED2',
        headline: navItems[0].title,
        id: navItems[0].id,
        paragraphs: [
          {
            title: 'Seamless integration',
            description: `Use our core programs or integrate easily with existing Broker and underwriter platforms, third-party data providers, policy management systems, reporting and dashboard systems,
            email providers and payment providers.`,
          },
          {
            title: `Audit trail`,
            description: `Track and log all actions and amendments made throughout the policy lifecycle. Defined processes ensure compliance with regulations.`,
          },
          {
            title: `Direct engagement`,
            description: `Cloud-based submissions give all parties in the value chain instant access to documents and streamline time-consuming processes - giving you the time to focus on what really matters.`,
          },

          {
            title: `Other features`,
            description: `
            <ul>
              <li>Flexible document creation service</li>
              <li>Document management and storage</li>
              <li>Track and view all changes in real time</li>
              <li>Centralised administration</li>
            </ul>
            `,
          },
        ],
      },
      {
        color: '#FB5457',
        headline: navItems[1].title,
        id: navItems[1].id,
        paragraphs: [
          {
            title: `Digital contract platform`,
            description: `Quote, collaborate and negotiate, policy binding, endorsements, cancellations, renewals`,
          },
          {
            title: `Digital distribution`,
            description: `Broker hierarchy, location-specific products, underwriting facilities. `,
          },
          {
            title: `Other features`,
            description: `
            <ul>
              <li>Digital contract with tailored data points</li>
              <li>Electronic/digital signatures</li>
              <li>Define structured insurance products</li>
            </ul>
            `,
          },
        ],
      },
      {
        color: '#8039FB',
        headline: navItems[2].title,
        id: navItems[2].id,
        columnsDisplay: true,
        paragraphs: [
          {
            title: `Extract data from emails, attachments and files`,
            description: `Digitise data from emails, attachments and paper-based submissions or extract points from text and image-based documents using pioneering Machine Learning techniques.`,
          },
          {
            title: `Identification of risk threats`,
            description: `Embrace the power of data to forecast future risks and observe correlations between risk variables.`,
          },
          {
            title: `Other features`,
            description: `
            <ul>
              <li>Collect and structure risk information</li>
              <li>Capture claim information from customers</li>
              <li>Configurable data collection rulesets</li>
              <li>Pattern analysis and linking policies</li>
            </ul>
            `,
          },
          {
            title: `Rules-based and ML automation`,
            description: `Using Machine Learning, our Claim Automation application helps you optimise profits by recognising and summarising the content of claims documents and continuously learning patterns to suggest improvements for future decision making.`,
          },
          {
            title: `White labelled web portals across all platforms`,
            description: `Our dynamically generated and white label websites and apps ensure simple, beautiful customer experiences with a single point of data capture. The <strong>artificialOS</strong> platform allows for visual customisation or integration with your existing applications using our APIs and SDKs.`,
          },
        ],
      },
      {
        color: '#FFAB3E',
        headline: navItems[3].title,
        id: navItems[3].id,
        paragraphs: [
          {
            title: `Automate risk scoring and pricing`,
            description: `Automatic scoring uses data to demonstrate the quality of a risk, its fit within the current portfolio of business and the likelihood of a potential claim. Brokers and underwriters then receive a reliable initial analysis of any submission, without the heaps of paperwork.`,
          },
          {
            title: `Integration with any data set or API`,
            description: `Our applications are API-first and allow for seamless third-party integration - so your underwriters and brokers can make fully-informed decisions without the effort of traditional data collection.`,
          },
          {
            title: `Other features`,
            description: `
            <ul>
              <li>Manually edit rates</li>
              <li>Baseline and enhance current pricing methods</li>
              <li>Collaborate and create bespoke Machine Learning-driven pricing engines</li>
              <li>Integration with existing pricing tools and systems</li>
            </ul>
            `,
          },
        ],
      },
      {
        color: '#9EBBFF',
        headline: navItems[4].title,
        id: navItems[4].id,
        columnsDisplay: true,
        paragraphs: [
          {
            title: `Single customer view of policies`,
            description: `Our platforms allow your customers to quote and buy insurance any time or place at a fraction of the speed it used to take. Insurance product purchasing and deployment is made frictionless thanks to personalised, reliable and fully responsive web pages and platforms. `,
          },
          {
            title: `Other features`,
            description: `
            <ul>
              <li>Policy financials</li>
              <li>Endorsements</li>
              <li>Renewals</li>
              <li>Timeline</li>
            </ul>
            `,
          },
          {
            title: `Bordereau creation to various templates`,
            description: `Generate Bordereau reports compliant with the latest Lloyd's coverholder standards.`,
          },
          {
            title: `Post-bind policy lifecycle`,
            description: `Complaints and appeals, cancellation and termination, pre- and post-bind checks, first notification of loss.`,
          },
        ],
      },
    ],
  },
  ArCTASection: {
    title: 'Want to learn more?',
    cta: {
      label: 'Contact Us',
      url: routesConfig.contact(),
    },
    scBackgroundColor: variables.colors.asfalt,
  },
}
